import React, { type FC, type RefObject, useEffect, useState } from 'react';
import css from '../TemplatePage.scss';
import classNames from 'classnames';
import { MainCTAs } from './MainCTAs';
import { ChevronLeft } from '@wix/wix-ui-icons-common';
import { usePageNavigate } from '../../../hooks/usePageNavigate';
import { PageHeaderTitle } from './PageHeaderTitle';
import { DataHooks } from '../../../constants/dataHooks';
import { getDivRefPosition } from '../../../utils/getDivRefPosition';
import { getScrollingElement } from '../../../utils/getScrollingElementInDocs';

type Props = {
  upperPartRef: RefObject<HTMLDivElement>;
};

export const StickyHeader: FC<Props> = ({ upperPartRef }) => {
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const isVisibleRef = React.useRef(false); // to memoize and spare setStateActions
  const { navigateToMainPage } = usePageNavigate();

  useEffect(() => {
    const handleScroll = () => {
      const bottomOfUpperPart = getDivRefPosition(upperPartRef, 'bottom');
      const shouldShowStickyHeader = bottomOfUpperPart <= 0;
      if (shouldShowStickyHeader !== isVisibleRef.current) {
        setIsVisible(shouldShowStickyHeader);
        isVisibleRef.current = shouldShowStickyHeader;
      }
    };

    const scrollingElement = getScrollingElement();
    scrollingElement.addEventListener('scroll', handleScroll);
    return () => scrollingElement.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div
      data-hook={DataHooks.StickyHeaderWrapper}
      className={classNames(css.stickyHeaderWrapper, {
        [css.stickyHeaderHidden]: !isVisible,
      })}
    >
      <div className={css.stickyHeaderContent}>
        <div className={css.leftSideStickyHeader}>
          <ChevronLeft
            data-hook={DataHooks.ChevronLeftStickyHeader}
            onClick={navigateToMainPage}
            className={css.breadcrumbIcon}
          />
          <PageHeaderTitle isStickyHeaderTitle />
        </div>
        <MainCTAs isStickyHeaderCTAs />
      </div>
    </div>
  );
};
